module.exports = __webpack_public_path__ + "img/profile-img.0dc80362.png";